import { groupByExperiments } from './groupByExperiments';
import { convertOneExperiment } from './util/convertOneExperiment.js';

/**
 *
 * @param {*} fileCollection
 * @param {object} [options={}]
 * @param {object} [options.filter]
 * @param {object} [options.converter]
 * @returns
 */
export async function convertFileCollection(fileCollection, options = {}) {
  const { filter, converter } = options;
  const results = [];
  const experiments = groupByExperiments(fileCollection, filter);
  for (let experiment of experiments) {
    const result = await convertOneExperiment(experiment, converter);
    if (result) {
      results.push(result);
    }
  }
  return results;
}
